import styled from 'styled-components';
import Select from 'components/Select';

export const Container = styled.div`
  height: 100%;

  main {
    height: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const BidderContainer = styled.div`
  width: 100%;
  margin-top: 1rem;
  background: ${({ theme }) => theme.colors.white};
  min-height: calc(100% - 229px);
  height: auto;
  border-radius: 30px;
  padding: 1.5rem;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  .selectContainer {
    width: 100%;
    display: flex;
    gap: 24px;
    margin-bottom: 25px;
  }
`;

export const SelectStyled = styled(Select)`
  width: 100%;
`;